export default ['$q', 'JsonRPCService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function ($q, JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var xCenterRoute = xCenterRouteConfig;
    var endpoint = 'coverage/coverage';

    return {
        getDependentCoveragesForLob: function getDependentCoveragesForLob(jobNumber) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'getDependentCoveragesForLob', [jobNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policyjob/services/CoverageService.js
// module id = 2100
// module chunks = 0